import { useStore } from '@/store';
import * as App from '@/types/app';
import * as Database from '@/types/database';

export const initSyncFirestoreWithVuexStore = async () => {
  const store = useStore();
  const groupId = await store.dispatch.groups.getGroupId();
  if (!groupId) return;

  const storeModules = Object.values(store.dispatch) as { initFirestoreSync?: () => Promise<void> }[];
  await Promise.all(storeModules.map(module => module.initFirestoreSync?.()));
};

export const killFirestoreListeners = async () => {
  const store = useStore();
  const storeModules = Object.values(store.dispatch) as { killFirestoreSync?: () => Promise<void> }[];
  await Promise.all(storeModules.map(module => module.killFirestoreSync?.()));
};

export const removeIdAndLastUpdatedOnFields = <T extends App.Model | Database.Model>(obj: T) => {
  const copiedObj = { ...obj };

  delete copiedObj.id;
  delete copiedObj.lastUpdatedOn;

  return copiedObj;
};
